module.exports = __webpack_public_path__ + "img/logo.2bab01da.jpeg";